// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NOc_","badges":"styles_badges__1WRL-"};